import useBlProviders from '@/composables/providers/useBlProvider'
import WorkReportDocumentsDt from '@/services/dataTransferModules/workReportDocumentsDt'

export default function useWorkReportDocuments(params = {}) {
	const workReportDocumentsDt = new WorkReportDocumentsDt()

	const defaults = {
		creatingWorkReportDocument: {
			title: '',
			description: '',
			example: null,
		},
		fieldsToPatch: ['title', 'description', 'photo_file_id'],
	}

	const {
		loadEntityFlags: flags,

		entities: workReportDocuments,
		getEntities: getWorkReportDocuments,

		createEntity: createWorkReportDocument,

		entity: workReportDocument,
		getEntity: getWorkReportDocument,

		patchEntity: putWorkReportDocument,
		updateEntity: updateWorkReportDocument,

		deleteEntity: deleteWorkReportDocument,
	} = useBlProviders(
		workReportDocumentsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		defaults,
		workReportDocuments,
		workReportDocument,
		getWorkReportDocuments,
		getWorkReportDocument,
		createWorkReportDocument,
		putWorkReportDocument,
		updateWorkReportDocument,
		deleteWorkReportDocument,
	}
}
